module.exports = __webpack_public_path__ + "static/media/maximize.98ce28eb.svg";